import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardFooter,
  Label,
  InputGroup,
  Input,
  Form,
  Alert
} from 'reactstrap'
import { patch, post, del } from '../../modules/API'
import { StickyContainer, Sticky } from 'react-sticky'

import FieldText from './FieldText'
import FieldRadio from './FieldRadio'
import FieldCheckbox from './FieldCheckbox'
import FieldSelect from './FieldSelect'
import FieldDate from './FieldDate'
import FieldDatetime from './FieldDatetime'
import FieldTime from './FieldTime'
import FieldSingleImage from './FieldSingleImage'
import FieldHidden from './FieldHidden'
import FieldTextarea from './FieldTextarea'

import ScheduleCard from './ScheduleCard'
import ServicesCard from './ServicesCard'

class EditableCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditing: props.newCard || false,
      isCancelling: false,
      isDeleting: false,
      isDisplayingSubmitMessage: false,
      cardFields: props.cardFields,
      fieldErrors: []
    }

    this.switchEditingMode = this.switchEditingMode.bind(this)
    this.handleInputBlur = this.handleInputBlur.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmitForm = this.handleSubmitForm.bind(this)
    this.handleCancelChanges = this.handleCancelChanges.bind(this)
    this.abortCancelChanges = this.abortCancelChanges.bind(this)
    this.confirmCancelChanges = this.confirmCancelChanges.bind(this)
    this.checkFields = this.checkFields.bind(this)
    this.handleSubmitForm = this.handleSubmitForm.bind(this)
    this.handleDeleteCard = this.handleDeleteCard.bind(this)
    this.abortDeleteCard = this.abortDeleteCard.bind(this)
    this.confirmDeleteCard = this.confirmDeleteCard.bind(this)
  }

  switchEditingMode() {
    if (this.state.isEditing) {
      this.handleCancelChanges()
    } else {
      this.setState(prevState => {
        this.props.setEditingMode(!prevState.isEditing)
        return {
          ...prevState,
          isEditing: !prevState.isEditing,
        }
      })
    }
  }

  handleInputBlur() {

  }

  handleInputChange() {

  }

  handleCancelChanges(ev) {
    let changes = this.checkFields(true)

    if (changes.length > 0) {
      this.setState({
        isCancelling: true
      })
    } else {
      this.props.setEditingMode(false)
      this.setState(prevState => {
        return {
          ...prevState,
          isCancelling: false,
          isEditing: false
        }
      })
    }
  }

  abortCancelChanges() {
    this.setState({
      isCancelling: false
    })
  }

  confirmCancelChanges() {
    if (this.props.newCard) {
      if (/faces/.test(this.props.fetchData.endpoint)) {
        this.props.cancelAddFace()
      } else if (/experiences/.test(this.props.fetchData.endpoint)) {
        this.props.cancelAddExperience()
      } else if (/events/.test(this.props.fetchData.endpoint)) {
        this.props.cancelAddEvent()
      }
    } else {
      this.props.setEditingMode(false)
      this.setState(prevState => {
        return {
          ...prevState,
          isCancelling: false,
          isEditing: false
        }
      })
    }
  }

  handleDeleteCard() {
    this.setState({
      isDeleting: true
    })
  }

  abortDeleteCard() {
    this.setState({
      isDeleting: false
    })
  }

  confirmDeleteCard() {
    let endpoint = this.props.fetchData.endpoint
    if (this.props.fetchData.endpointOptions && this.props.fetchData.endpointOptions.isDynamic) {
      let endpointField = this.props.cardFields.find(el => el.id === this.props.fetchData.endpointOptions.field).fieldValue;

      endpoint = endpoint.replace(this.props.fetchData.endpointOptions.field, endpointField)
    }

    del(endpoint)
      .then(data => {
        if (/faces/.test(endpoint)) {
          this.props.deleteFace(this.props.id)
        } else if (/experiences/.test(endpoint)) {
          this.props.deleteExperience(this.props.id)
        } else if (/events/.test(endpoint)) {
          this.props.deleteEvent(this.props.id)
        }

        this.props.setEditingMode(false)
      })
  }

  checkFields(checkForChanges) {
    let returnValue = fieldId => {
      if (/(opening_hours)|(lunch_break)/.test(fieldId)) {
        return this.refs['opening-times'].returnValue(fieldId)
      } else if (/services/.test(fieldId)) {
        return this.refs['services'].returnValue(fieldId)
      } else {
        return this[fieldId].returnValue()
      }
    }

    let cardFields = this.state.cardFields.map(cardField => {
        return {
          ...cardField,
          fieldValue: returnValue(cardField.id)
        }
      })

    return this.state.cardFields.map(cardField => {
      let oldCardField = this.props.cardFields.find(el => el.id === cardField.id)
      let cardFieldValue = returnValue(cardField.id)

      if (this.props.fetchData.method === 'post') {
        return cardFieldValue && {
          [cardField.id]: cardFieldValue
        }
      } else {
        let oldCardFieldString = oldCardField.fieldValue && oldCardField.fieldValue.toString() || null
        let cardFieldValueString = cardFieldValue && cardFieldValue.toString() || null

        if (checkForChanges) {
          // only check elements that have been changed
          if (oldCardFieldString !== cardFieldValueString) {
            return {
              [cardField.id]: cardFieldValue ? cardFieldValue : null
            }
          }
        } else {
          // only post elements that have been changed
          if (oldCardFieldString !== cardFieldValueString || this.props.fetchData.force) {
            return {
              [cardField.id]: cardFieldValue ? cardFieldValue : null
            }
          }
        }
      }
    }).filter(el => el)
  }

  handleSubmitForm(ev) {
    ev.preventDefault()

    if (!this.form.checkValidity()) {
      this.form.classList.add('was-validated')

      this.setState({
        fieldErrors: ['Bitte überprüfen Sie Ihre Eingabe.']
      })

      return false
    } else {
      this.form.classList.remove('was-validated')
    }

    let requestPayload = this.checkFields()

    let endpoint = this.props.fetchData.endpoint
    if (this.props.fetchData.endpointOptions && this.props.fetchData.endpointOptions.isDynamic) {
      let cardField
      requestPayload.map(el => {
        if (el && Object.keys(el)[0] === this.props.fetchData.endpointOptions.field) {
          cardField = {
            id: this.props.fetchData.endpointOptions.field,
            fieldValue: Object.values(el)[0]
          }
        }
      })

      if (!cardField) {
        cardField = this.props.cardFields.find(el => el.id === this.props.fetchData.endpointOptions.field)
      }

      let endpointField = cardField && cardField.fieldValue ? cardField.fieldValue :
                          returnValue(this.props.fetchData.endpointOptions.field)

      endpoint = endpoint.replace(this.props.fetchData.endpointOptions.field, endpointField)
    }

    let request
    if (this.props.fetchData.method === 'post') {
      request = post(endpoint, Object.assign({}, ...requestPayload))
    } else {
      request = patch(endpoint, Object.assign({}, ...requestPayload))
    }

    request.then(data => {
      this.props.setEditingMode(false)
      this.setState({
        isEditing: false,
        fieldErrors: []
      })

      if (this.props.fetchData.method === 'post') {
        if (/faces/.test(endpoint)) {
          this.props.addFace(data)
        } else if (/experiences/.test(endpoint)) {
          this.props.addExperience(data)
        } else if (/events/.test(endpoint)) {
          this.props.addEvent(data)
        }
      }

      if (this.props.fetchData.method === 'patch') {
        let model = 'profile'
        if (/faces/.test(endpoint)) {
          model = 'faces'
        } else if (/experiences/.test(endpoint)) {
          model = 'experiences'
        } else if (/events/.test(endpoint)) {
          model = 'events'
        }

        this.props.updateModel(model, data)

        if (this.props.cardSubmitMessage) {
          this.setState({
            isDisplayingSubmitMessage: true
          })
        }
      }
    }, error => {
      this.setState(prevState => {
        let fieldErrors = new Set()

        Object.keys(error.payload).map(el => {
          fieldErrors.add(error.payload[el])
        })

        return {
          fieldErrors: [...fieldErrors]
        }
      })
    })
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      cardFields: nextProps.cardFields
    })
  }

  render() {
    const blurredClass = this.state.isCancelling || this.state.isDeleting ? ' is-blurred' : ''

    let cardClass = 'editable-card'
        cardClass += blurredClass
        cardClass += this.state.isEditing ? ' is-editing' : ' is-viewing'
        cardClass += this.props.cardTemplate === 'event' ? ' event-card' : ''
        cardClass += this.props.newCard ? ' new-card' : ' current-card'

    let customCard
    if (this.props.customCard) {
      switch (this.props.customCard) {
        case 'opening-times':
          customCard = <ScheduleCard
                          cardFields={this.state.cardFields}
                          isEditing={this.state.isEditing}
                          cardType={this.props.cardType}
                          ref="opening-times"
                        />
          break

        case 'services':
          customCard = <ServicesCard
                          cardFields={this.state.cardFields}
                          isEditing={this.state.isEditing}
                          cardType={this.props.cardType}
                          ref="services"
                        />
      }
    }

    const cardFields = customCard ? customCard :
      this.state.cardFields.map(cardField => {
        const cardProps = {
          key: cardField.id,
          cardField: cardField,
          isEditing: this.state.isEditing,
          cardType: this.props.cardType,
          ref: el => this[cardField.id] = el
        }

        switch (cardField.fieldType) {
          case 'single_image':
            return <FieldSingleImage
              {...cardProps}
            />

          case 'radio':
            return <FieldRadio
              {...cardProps}
            />

          case 'checkbox':
            return <FieldCheckbox
              {...cardProps}
            />

          case 'select':
            return <FieldSelect
              {...cardProps}
            />

          case 'datetime':
            return <FieldDatetime
              {...cardProps}
            />

          case 'date':
            return <FieldDate
              {...cardProps}
            />

          case 'time':
            return <FieldTime
              {...cardProps}
            />

          case 'hidden':
            return <FieldHidden
              {...cardProps}
            />

          case 'textarea':
            return <FieldTextarea
              {...cardProps}
            />

          default: // default is text
            return <FieldText
              {...cardProps}
            />
        }
      })

    const displayError = (this.state.isEditing || this.props.cardType === 'always-on') && this.state.fieldErrors.length > 0 &&
                         <Alert color="danger" className="mb-0 mt-3 p-2">
                           {this.state.fieldErrors.map((error, index) => <div key={`errors-${index}`}><i className="icon-bell"></i> {error}</div>)}
                         </Alert>

    const saveCancelButtons = (style, isSticky) => {
      if (!this.state.isEditing) {
        style = {
          ...style,
          display: 'none'
        }
      }

      return <div className={`card-footer card-footer-sticky ${isSticky ? 'is-stuck' : ''} ${blurredClass}`} style={style}>
               <Row>
                 <Col xs="6">
                   <Button type="submit" color="primary" block>Speichern</Button>
                 </Col>
                 {this.props.cardType !== 'always-on' && <Col xs="6">
                   <Button color="primary" outline block onClick={this.handleCancelChanges}>Abbrechen</Button>
                 </Col>}
               </Row>
               <Row>
                 <Col>
                   {displayError}
                 </Col>
               </Row>
             </div>
    }

    const saveSettings = this.props.cardType === 'always-on' &&
                        <CardFooter className={blurredClass}>
                           <Row>
                             <Col xs="6">
                               <Button type="submit" color="primary" block>Speichern</Button>
                             </Col>
                           </Row>
                         </CardFooter>


    const displaySubmitMessage = this.state.isDisplayingSubmitMessage &&
                                <div className="card-overlay-question card-overlay-question-primary">
                                  <div>{this.props.cardSubmitMessage}</div>
                                </div>

    const cancelWarning = this.state.isCancelling &&
                          <div className="card-overlay-question">
                            <div>Änderungen verwerfen?</div>
                            <div>
                              <Button color="warning" onClick={this.confirmCancelChanges}>Ja</Button>
                              <Button color="primary" outline onClick={this.abortCancelChanges}>Nein</Button>
                            </div>
                          </div>

    const deleteWarning = this.state.isDeleting &&
                          <div className="card-overlay-question">
                            <div>{this.props.cardDeleteMessage}</div>
                            <div>
                              <Button color="danger" onClick={this.confirmDeleteCard}>Löschen</Button>
                              <Button color="primary" outline onClick={this.abortDeleteCard}>Abbrechen</Button>
                            </div>
                          </div>

    return (
      <Card>
        <Form onSubmit={this.handleSubmitForm} innerRef={el => { this.form = el }} noValidate>
          <StickyContainer>
            <Sticky topOffset={-55} bottomOffset={55}>
              {
                ({
                  style,
                  isSticky,
                  wasSticky,
                  distanceFromTop,
                  distanceFromBottom,
                  calculatedHeight
                }) => {
                  return saveCancelButtons(style, isSticky)
                }
              }
            </Sticky>
            <CardBody className={cardClass}>
              {this.props.cardType !== 'always-on' && !this.props.newCard && [
                this.props.isDeletable && <Button
                  key="delete"
                  color="danger"
                  size="sm"
                  className="float-right ml-1"
                  onClick={this.handleDeleteCard}>
                    <i className="icon-trash"></i>
                </Button>,
                !this.props.disableEdit && <Button
                  key="edit"
                  color="primary"
                  outline={this.state.isEditing}
                  size="sm"
                  className="float-right"
                  onClick={this.switchEditingMode}>
                    <i className="icon-pencil"></i> Bearbeiten
                </Button>
                ]
              }
              <CardTitle>{this.props.cardTitle}</CardTitle>
              {this.props.cardInstructions}
              {this.props.cardSubtitle ? <p>{this.props.cardSubtitle}</p> : null}
              {cardFields}
              {this.props.cardType === 'always-on' && displayError}
            </CardBody>
            {saveSettings}
            {displaySubmitMessage}
            {cancelWarning}
            {deleteWarning}
          </StickyContainer>
        </Form>
      </Card>
    )
  }
}

EditableCard.propTypes = {
  id: PropTypes.number,
  cardTitle: PropTypes.string,
  cardSubtitle: PropTypes.string,
  cardFields: PropTypes.array.isRequired,
  cardTemplate: PropTypes.string,
  cardType: PropTypes.string,
  fetchData: PropTypes.object,

  getEditingMode: PropTypes.bool,
  setEditingMode: PropTypes.func,

  newCard: PropTypes.bool,
  addFace: PropTypes.func,
  addExperience: PropTypes.func,
  cancelAddFace: PropTypes.func,
  cancelAddExperience: PropTypes.func,
  isDeletable: PropTypes.bool
}

EditableCard.defaultProps = {
  cardType: 'toggle',
  cardTemplate: 'default'
}

export default EditableCard;



// WEBPACK FOOTER //
// ./src/components/EditableCard/EditableCard.js